<template>
    <header :aria-label="$t('header')">
        <div id="header" class="row align-items-center">
            <div class="col-1" v-bind:class="($screen.width <= 575) ? 'responsive-header':''">
                <button v-b-modal.settings-modal class="header-button me-4" :aria-label="$t('settings.experience-settings')">
                    <img src="@/assets/images/setting-purple@2x.png" :alt="$t('settings.experience-settings')">
                </button>
            </div>
            <div class="col-1 d-none d-sm-none d-md-block" v-bind:class="($screen.width <= 575) ? 'responsive-header':''">
                <button class="header-button me-4" @click="home" :aria-label="$t('home-icon')" v-if="!$route.name.includes('home')">
                    <font-awesome-icon class="home-icon text-primary" :icon="['fas', 'home']" />
                </button>
            </div>
            <div class="col">
                <div class="row align-items-center justify-content-end">
                    <div class="col-6 col-sm-2 col-md-2 col-lg-2 col-xl-2 p-0 justify-content-end">
                        <header-font-button v-bind:fontSize="fontSize"></header-font-button>
                    </div>
                    <div class="col-4 col-sm-3 col-md-3 col-lg-2 col-xl-2 justify-content-end">
                        <header-locale-button></header-locale-button>
                    </div>
                </div>
            </div>
        </div>
        <settings></settings>
    </header>
</template>

<script>

export default {
    props: ['fontSize'],
    data () {
        return {

        };
    },
    methods: {
        /**
         * Go to home page.
         */
        home () {
            // Go to home page
            this.$router.push({ name: `home:${this.$i18n.locale}` });
        }
    }
}
</script>
